/**
 * Configurable logger utility
 *
 * Logging behavior:
 * - Development mode (npm run dev): Always enabled
 * - Production mode (npm run build):
 *   - If VITE_ENABLE_LOGGING is not set: Disabled (safe default)
 *   - If VITE_ENABLE_LOGGING="true": Enabled
 *   - If VITE_ENABLE_LOGGING="false": Disabled
 */

const isLoggingEnabled = import.meta.env.DEV || import.meta.env.VITE_ENABLE_LOGGING === "true";

export const logger = {
    log: (...args: unknown[]) => {
        if (isLoggingEnabled) {
            console.log(...args);
        }
    },

    error: (...args: unknown[]) => {
        if (isLoggingEnabled) {
            console.error(...args);
        }
    },

    warn: (...args: unknown[]) => {
        if (isLoggingEnabled) {
            console.warn(...args);
        }
    },

    info: (...args: unknown[]) => {
        if (isLoggingEnabled) {
            console.info(...args);
        }
    },

    debug: (...args: unknown[]) => {
        if (isLoggingEnabled) {
            console.debug(...args);
        }
    },
};
